import { render, staticRenderFns } from "./SfCollectedProduct.vue?vue&type=template&id=b33c5728&"
import script from "./SfCollectedProduct.vue?vue&type=script&lang=js&"
export * from "./SfCollectedProduct.vue?vue&type=script&lang=js&"
import style0 from "./SfCollectedProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports